const ADMIN_EMAILS = (process.env.REACT_APP_ADMIN_EMAILS || '')
  .split(',')
  .map((email) => email.trim())
  .filter(Boolean);

export function isAdminEmail(email) {
  if (!email) {
    return false;
  }
  return ADMIN_EMAILS.includes(email);
}
